import { Link } from 'react-router-dom';

const StudyLinkForeignKey = (props) => {
  const client = localStorage.getItem('client')

  return (
    <Link to={`/${client}/studies/` + props.data?.study_uid}>{props.data?.org_study_id}</Link>
  );
};

export default StudyLinkForeignKey;
